import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Newsletter from "../views/Newsletter";
import OZGServiceExplorer from "../components/explorers/OZGServiceExplorer";
import OZGTimelineStatusExplorer from "../components/explorers/OZGTimelineStatusExplorer";
import OZGAggregateGanttChatExplorer from "../components/explorers/OZGAggregateGanttChatExplorer";
import OZGImplementationLevelSwitchExplorer from "../components/explorers/OZGImplementationLevelSwitchExplorer";
import funFactNumbers from "../components/numbers/funFactNumbers";
import OZGCountyMap from "../components/OZGCountyMap";
import OnlineServiceDataQuality from "../components/visualisations/OnlineServiceDataQuality";
import OnlineServiceFeatureDataQuality from "../components/visualisations/OnlineServiceFeatureDataQuality";
import OZGServiceFeatureNotImplementableReason
  from "../components/visualisations/OZGServiceFeatureNotImplementableReason";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/newsletter/",
    name: "Newsletter",
    component: Newsletter
  },
  {
    path: "/service-explorer/",
    name: "ServiceExplorer",
    component: OZGServiceExplorer
  },
  {
    path: "/timeline-explorer/",
    name: "TimelineExplorer",
    component: OZGTimelineStatusExplorer
  },
  {
    path: "/gantt-explorer/",
    name: "GanttExplorer",
    component: OZGAggregateGanttChatExplorer
  },
  {
    path: "/implementation-level-explorer/",
    name: "ImplementationLevelExplorer",
    component: OZGImplementationLevelSwitchExplorer
  },
  {
    path: "/ozg-numbers/",
    name: "OZGNumbers",
    component: funFactNumbers
  },
  {
    path: "/county-map/",
    name: "OZGCountyMap",
    component: OZGCountyMap
  },
  {
    path: "/onlineservice-data-quality/",
    name: "OnlineServiceDataQuality",
    component: OnlineServiceDataQuality
  },
  {
    path: "/onlineservice-feature-data-quality/",
    name: "OnlineServiceFeatureDataQuality",
    component: OnlineServiceFeatureDataQuality
  },
  {
    path: "/service-feature-not-implemented-reason/",
    name: "OZGServiceFeatureNotImplementableReason",
    component: OZGServiceFeatureNotImplementableReason
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
